import DOMPurify from "dompurify";

const HTMLSanitize = {
  install(Vue) {
    Vue.directive("safe-html", {
      inserted: function (el, binding) {
        el.innerHTML = DOMPurify.sanitize(binding.value);
      },
      update: function (el, binding) {
        el.innerHTML = DOMPurify.sanitize(binding.value);
      }
    });

    Vue.directive("safe-href", {
      inserted: function (el, binding) {
        el.href = DOMPurify.sanitize(binding.value);
      },
      update: function (el, binding) {
        el.href = DOMPurify.sanitize(binding.value);
      }
    });
  }
};

export default HTMLSanitize;
